"use client";

import { type ReactNode, type ErrorInfo, useCallback } from "react";
import * as Sentry from "@sentry/react";
import ErrorBoundary from "./ErrorBoundary";
import ErrorPage from "./errorPage";

/**
 * 放在 layout 最外层（紧贴 body），用于捕获 Home、各 Provider、以及 page 之上整棵子树的渲染错误。
 * 仅嵌在聊天里的 ErrorBoundary 无法覆盖首屏 / 非聊天路由的崩溃。
 */
export function RootErrorBoundary({ children }: { children: ReactNode }) {
  const onError = useCallback((error: Error, errorInfo: ErrorInfo) => {
    Sentry.captureException(error, {
      tags: { errorBoundary: "RootErrorBoundary" },
      extra: { componentStack: errorInfo.componentStack },
    });
  }, []);

  return (
    <ErrorBoundary
      onError={onError}
      fallback={(error) => (
        <ErrorPage errorMsg={error.message || ""} canRetry />
      )}
    >
      {children}
    </ErrorBoundary>
  );
}
